import PatientActivityLogs from './PatientActivityLogs';

export default PatientActivityLogs;
